module.exports = __webpack_public_path__ + "img/icon-lugares.56bca030.svg";